<template>
  <div>
    <div
      class="sp"
      v-for="(item, index) in list"
      :key="index"
      @click="clickVideo(item)"
    >
      <div class="pos">
        <van-image
          fit="cover"
          width="100%"
          height="100%"
          :src="item.thumb || item.goods_thumb"
          alt=""
        />
        <div class="play">
          <i class="iconfont icon-bofang"></i>
        </div>
        <div class="tag">推荐</div>
      </div>
      <div class="sp-info">
        <div class="sp-title">
          <p>{{ item.title }} <template v-if="item.Tname">- {{item.Tname}}</template></p>
        </div>
        <div class="sp-state">
          <span
            class="sp-s"
            style="font-size: 0.32rem; color: #f05468"
            v-if="item.type == 1"
          >
            <small style="font-size: 12px">￥</small>
            {{ item.pay_type != 'system' ? item.price : item.money }}
          </span>
          <span class="sp-s" v-else>免费</span>
          <span class="eye">
            <i class="iconfont icon-yanjing"></i>
            {{item.readNum}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
@description:课程组件
@createTime:2021-08-20
@create:wq
*/
export default {
  name: "",
  props: ["list", "order","type"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {
    clickVideo(item) {
      if (this.order) {
        this.$router.push({ path: "/kcdetails", query: { id: item.tid } });
      } else {
        if(this.type == 1){
          this.$router.push({ path: "/kcdetails", query: { id: item.goods_id } });
          return
        }
        this.$router.push({ path: "/kcdetails", query: { id: item.id } });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sp {
  margin: 0.28rem 0;

  border-radius: 0.28rem;
  overflow: hidden;
  .pos {
    width: 100%;
    height: 3.05rem;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
    }
    .tag {
      position: absolute;
      top: 10px;
      left: -30px;
      background: #f2c23e;
      color: #ffffff;
      width: 100px;
      text-align: center;
      transform: rotate(-45deg);
      font-size: 12px;
      padding: 2px;
    }
    .play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      i {
        color: white;
        font-size: 32px;
      }
    }
  }
  .sp-info {
    padding: 0.26rem;
    background: #f5f5f5;
    .sp-title {
      font-size: 0.28rem;
      font-weight: 400;
      color: #333333;
    }
    .sp-state {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .sp-s {
        font-size: 0.24rem;
        font-weight: 400;
        color: #2edb79;
      }

      .eye {
        font-size: 0.24rem;
        font-weight: 400;
        color: #cccccc;
        i {
          color: #999999;
          font-size: 0.27rem;
        }
      }
    }
  }
}
</style>
